namespace Gamification.Gamification {
    export interface CredenzialiRow {
        UserId?: number;
        TenantId?: number;
        IdCredenziale?: number;
        IdTipologiaCredenziale?: number;
        Nome?: string;
        Host?: string;
        Username?: string;
        Password?: string;
        Token?: string;
        IdTipologiaCredenzialeNome?: string;
        IdTipologiaCredenzialeDescrizione?: string;
    }

    export namespace CredenzialiRow {
        export const idProperty = 'IdCredenziale';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.Credenziali';
        export const lookupKey = 'Gamification:Credenziali';

        export function getLookup(): Q.Lookup<CredenzialiRow> {
            return Q.getLookup<CredenzialiRow>('Gamification:Credenziali');
        }
        export const deletePermission = 'Gamification:Risorse';
        export const insertPermission = 'Gamification:Risorse';
        export const readPermission = 'Gamification:Risorse';
        export const updatePermission = 'Gamification:Risorse';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdCredenziale = "IdCredenziale",
            IdTipologiaCredenziale = "IdTipologiaCredenziale",
            Nome = "Nome",
            Host = "Host",
            Username = "Username",
            Password = "Password",
            Token = "Token",
            IdTipologiaCredenzialeNome = "IdTipologiaCredenzialeNome",
            IdTipologiaCredenzialeDescrizione = "IdTipologiaCredenzialeDescrizione"
        }
    }
}
